import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validatePopup } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import DropDownSelect from '../DropDownSelect';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import { LoadingSpinner } from '../LoadingSpinner';

import { CountryCodes } from '../../utils/enums';

import {
    Title,
    Container,
    ButtonGroup,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

import { copyFor, capitalization } from '../../copy/copy';

class LocationChangeForm extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <Title>Postal Code</Title>
                <MultipleGroupFull>
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="countryCode"
                        countryCodeDropdown={true}
                        component={DropDownSelect}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'country',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        options={CountryCodes}
                    />
                </MultipleGroupFull>
                <ButtonGroup isAddressSubmitting={this.props.isPostalCodeSubmitting}>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label={copyFor(
                                'buttons',
                                'continue',
                                'volunteer',
                                capitalization.eachWord
                            )}
                            className="submitButton"
                            disabled={this.props.invalid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </Container>
        );
    }
}

LocationChangeForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isPostalCodeSubmitting: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            postalCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.postalCode
                : '',
            countryCode: state.widget.endUserLocation.countryCode
                ? state.widget.endUserLocation.countryCode
                : 'US'
        }
    })),
    reduxForm({
        form: 'volunteer',
        destroyOnUnmount: false,
        validate: validatePopup
    })
)(LocationChangeForm);



// WEBPACK FOOTER //
// ./src/components/Volunteer/LocationChangeForm.jsx